import { Card, CardContent } from '@/components/ui/Card.tsx';
import timeUtils from '@/utils/timeUtils.ts';
import TextInfoSection from '@/features/public/booking/components/TextInfoSection.tsx';
import WaitlistCta from '@/features/public/booking/components/WaitlistCta.tsx';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';

type BookingRegistrationClosedContentProps = {
  tourBasicInfo: BookingTourBasicDataDto;
};

/**
 * `CLOSED` znaczy teraz wyłącznie „po rzeczywistym końcu zapisów albo wyjazd
 * nieaktywny" — „jeszcze nie otwarte" jedzie osobnymi statusami (`PLANNED`,
 * `NOT_SCHEDULED`), więc nie zgadujemy już powodu z daty startu wyjazdu.
 */
const BookingRegistrationClosedContent = ({
  tourBasicInfo,
}: BookingRegistrationClosedContentProps) => {
  const { effectiveRegistrationEndDate } = tourBasicInfo.registrationDetails;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-base-text">
          Rejestracja na <b>{tourBasicInfo.tourName}</b> została zamknięta.
        </h1>

        <p className="text-neutral-500">
          Jeżeli uważasz, że to błąd, skontaktuj się z organizatorem, aby
          uzyskać więcej informacji.
        </p>
      </div>

      <WaitlistCta
        tourBasicInfo={tourBasicInfo}
        description="Zapisy są zamknięte, ale nadal możesz dołączyć do listy rezerwowej — organizator odezwie się, jeśli zwolni się miejsce."
      />

      <Card>
        <CardContent className="space-y-6">
          {effectiveRegistrationEndDate && (
            <TextInfoSection
              title="Zapisy zakończone"
              info={
                <p>
                  <span className="font-semibold">
                    {timeUtils.toDateTimeString(effectiveRegistrationEndDate)}
                  </span>
                </p>
              }
            />
          )}

          <TextInfoSection
            title="Termin wyjazdu"
            info={
              <>
                <p>
                  Rozpoczęcie:{' '}
                  <span className="font-semibold">
                    {timeUtils.toDateString(tourBasicInfo.startDate)}
                  </span>
                </p>
                <p>
                  Zakończenie:{' '}
                  <span className="font-semibold">
                    {timeUtils.toDateString(tourBasicInfo.endDate)}
                  </span>
                </p>
              </>
            }
          />

          {tourBasicInfo.tourDescription &&
            tourBasicInfo.tourDescription.length > 0 && (
              <TextInfoSection
                title="Opis wyjazdu"
                info={tourBasicInfo.tourDescription}
              />
            )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BookingRegistrationClosedContent;
